import store from '@/store'
let {
	imageCompressWidth,
	api
} = store.getters
/**
 * @param {arr} list 浏览图片的列表数组
 * @param {object} row  数组中当前图片对象的信息
 * @param {number} index  当前图片对象的下表
 * @param {string} type  当前点击的是否是眼睛图片（original代表原图，默认不传）
 * @param {string} title 图片描述(如审计图片等)
 * @param {number} error 图片记录状态 0:正常  -1:异常
 * @param {object} _this 当前vue实例对象
 **/
async function previewImage(list, row, index, _this, other) {
	let {
		title,
		error,
		type
	} = other
	_this.$lizhao.throttle(async () => {
		if (row.fileUrl == '../../static/img/qss/qss.png' && row.enType == 3) {
			if (row.enSave == 0||row.enSave == 2) { //如果后台是密文存储无需再次请求接口 0,2后台明文1密文
				let decryptData = await quantumCryptographyPretreatment(row, _this)
				if (decryptData) {
					row.QssfileUrl = decryptData.fileUrl
					row.enSave = decryptData.enSave
					setTimeout(() => {
						previewImage(list, row, index, _this, other)
					}, 500)
				}
				return
			}
			// 国盾量子
			let base64 = await _this.$lizhao.gdQSS.resolveLocalFileSystemURL(row.QssfileUrl)
			row.fileUrl = await _this.$lizhao.gdQSS.decrypt(row.secretKey, base64)
			let arr = [row]
			seeImage(list, row, index, _this, other)
		} else if (row.fileUrl == '../../static/img/qss/qss.png' && row.enType == 4) {
			// 国科量子
			let base64 = await _this.$lizhao.gdQSS.resolveLocalFileSystemURL(row.QssfileUrl)
			let obj = await _this.$lizhao.gkQSS.decrypt(row.secretKey, base64, row.fileId)
			if (obj && obj.code == 200) {
				row.fileUrl = obj.data
			}
		} else {
			// 非量子图片
			seeImage(list, row, index, _this, other)
		}
	}, 500, true)
}
function seeImage(list, row, index, _this, other) {
	let {
		title,
		error,
		type
	} = other
	_this.picture.showIndex = index
	_this.picture.urlList = list
	if (_this.picture.urlList && _this.picture.urlList.length > 0) {
		_this.picture.urlList.forEach(file => {
			file.title = title
			file.error = error
		})
	}
	_this.picture.showViewer = true
}
/**
 * 获取后台数据后对数据进行处理，如果是量子的界面显示中电信加密保护中的图片
 * @param {arr} data 后台返回数据
 * @param {object} type  根据返回的字段不一致做的处理，默认为1
 **/
function processingData(data, type = 1, _this) {
	if (type == 1) { //使用记录
		if (data.passwordUrls) {
			forEachFn(data.passwordUrls, _this)
		}
		if (data.applicationUrls) {
			forEachFn(data.applicationUrls, _this)
		}
		if (data.fingerUrls) {
			forEachFn(data.fingerUrls, _this)
		}
		if (data.exceedUrls) {
			forEachFn(data.exceedUrls, _this)
		}
		if (data.auditorUrls) {
			forEachFn(data.auditorUrls, _this)
		}
		if (data.timeOutUrls) {
			forEachFn(data.timeOutUrls, _this)
		}
		if (data.replenishUrls) {
			forEachFn(data.replenishUrls, _this)
		}
		if (data.temporaryUrls) {
			forEachFn(data.temporaryUrls, _this)
		}
	} else if (type == 2) {
		if (data.passwordUrls) {
			forEachFn(data.passwordUrls, _this)
		}
		if (data.applicationFiles) {
			forEachFn(data.applicationFiles, _this)
		}
		if (data.fingerUrls) {
			forEachFn(data.fingerUrls, _this)
		}
		if (data.exceedUrls) {
			forEachFn(data.exceedUrls, _this)
		}
		if (data.auditFiles) {
			forEachFn(data.auditFiles, _this)
		}
		if (data.timeOutUrls) {
			forEachFn(data.timeOutUrls, _this)
		}
		if (data.replenishUrls) {
			forEachFn(data.replenishUrls, _this)
		}
		if (data.useFiles) {
			forEachFn(data.useFiles, _this)
		}
	} else if (type == 3) { //申请单的使用记录
		if (data.infoList) {
			forEachFn(data.infoList, _this)
		}
		if (data.auditorList) {
			forEachFn(data.auditorList, _this)
		}
		if (data.overTimeList) {
			forEachFn(data.overTimeList, _this)
		}
		if (data.replenishList) {
			forEachFn(data.replenishList, _this)
		}
		if (data.temporaryList) {
			forEachFn(data.temporaryList, _this)
		}
		if (data.excessTimesList) {
			forEachFn(data.excessTimesList, _this)
		}
	} else if (type == 4) { //申请导出的使用记录
		if (data.imageUrls) {
			forEachFn(data.imageUrls, _this)
		}
		if (data.auditorList) {
			forEachFn(data.auditorList, _this)
		}
		if (data.overTimeList) {
			forEachFn(data.overTimeList, _this)
		}
		if (data.replenishList) {
			forEachFn(data.replenishList, _this)
		}
		if (data.temporaryList) {
			forEachFn(data.temporaryList, _this)
		}
		if (data.excessTimesList) {
			forEachFn(data.excessTimesList, _this)
		}
	}
	return data
}

function forEachFn(list, _this) {
	list.map(item => {
		//国盾加密类型
		if ((item.enType == 3&&item.enSave!=2) || item.enType == 4) {
			item.QssfileUrl = item.fileUrl
			item.fileUrl = "../../static/img/qss/qss.png"

		} else if (item.enType == 0) {
			item.fileUrl =
				`${item.fileUrl}?Authorization=${_this.userInfo.token}&width=${imageCompressWidth}&us=web`
		} else {
			item.fileUrl =
				`${item.fileUrl}?Authorization=${_this.userInfo.token}&width=${imageCompressWidth}&us=web`
		}
		return item
	})
}

function quantumCryptographyPretreatment(row, _this) {
	return new Promise((reslove, reject) => {
		_this.GLOBAL.doGet(_this.api.GLOBAL_file_fileInfo_quantumCryptographyPretreatment, {
			fileId: row.fileId
		}, function(res) {
			if (res.code == 200) {
				reslove(res.data)
			}
		});
	})
}
/**
 * computeImageUrlWithPath的重載方法
 */
function computeImageUrlWithPath(url, path) {
	if(process.env.NODE_ENV == 'development'){
		return url
	}
	let {userInfo} = store.getters
	if (path && path.length > 0) {
		let newUrl = `${api.GLOBAL_HOST_IMAGE}${path}?Authorization=${userInfo.token}&width=${imageCompressWidth}`
		return newUrl
	} else {
		if (url) {
			return `${url}?Authorization=${userInfo.token}&width=${imageCompressWidth}`;
		} else {
			return url
		}
	}
}

export default {
	previewImage,
	processingData,
	computeImageUrlWithPath
}



// WEBPACK FOOTER //
// ./static/js/function/seeImage.js